import { apiFetchJson } from './api';

/**
 * Fetch all active carriers
 * @param {Object} params - Query parameters
 * @param {boolean} params.is_active - Filter by active status
 * @returns {Promise<Object>} Response with results array
 */
export const fetchCarriers = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.is_active !== undefined) {
    queryParams.append('is_active', params.is_active);
  }

  const queryString = queryParams.toString();
  const url = queryString ? `/api/data-loads/carriers/?${queryString}` : '/api/data-loads/carriers/';
  return apiFetchJson(url);
};
